define('app/views/yadisa_sale_view',[
  'app/setup',
  'app/views/add_to_cart_form_view',
  'app/views/yadisa_buy_button_view'
], function(
  takhfifan,
  addToCartFormView,
  yadisaBuyButtonView
) {

  takhfifan.YadisaSaleView = Backbone.View.extend({

    initialize: function() {
      this.model.on('change', this.render, this);
      this.generateAddToCartForm();
      this.loadBuyButton();

      takhfifan.eventHub.on('timeover:' + this.$el.data('product-id'),
        function() {
          this.disable();
      }, this);
    },

    generateAddToCartForm: function() {
      if (this.$el.data('can-checkout') == 1) {
        var productId = this.$el.data('product-id');
        var $form = $('<form />').prop({
          method: 'post',
          action: '#'
        }).css('display', 'none');
        this.$el.append($form);

        new takhfifan.AddToCartFormView({
          el: $form,
          productId: productId
        });
      }
    },

    loadBuyButton: function() {
      var productId = this.$el.data('product-id');

      this.$('.tkh-yadisa-buy-btn').each(function() {
        new takhfifan.YadisaBuyButtonView({
          el: $(this),
          productId: productId
        });
      });
    },

    render: function(args) {
      this.$('.tkh-available').text(this.model.get('available'));
    },

    disable: function() {
      this.$('form').remove();
    }

  });

});

